import React from "react";
import { Link } from "react-router-dom";

import styles from "./Header.module.scss";
import penspaceLogo from "../../images/penspace-logo.png";

const NAV_LINKS = [
  { to: "/#features", label: "How it works" },
  { to: "/#key-features", label: "Features" },
  { to: "/#help", label: "Help" },
  { to: "/#contact", label: "Contact Us" },
];

export default function Header({
  showHome = false,
  headerRef,
  headerStyle,
  onLogoClick,
  onNavClick,
  mobileMenuOpen = false,
  onMobileMenuToggle,
}) {
  const useAnchorLinks = Boolean(onNavClick);

  return (
    <header
      className={styles.header}
      ref={headerRef}
      style={headerStyle}
    >
      <div className={styles.container}>
        <div className={styles.navWrapper}>
          <div className={styles.logo}>
            {onLogoClick ? (
              <button
                type="button"
                className={styles.logoLink}
                aria-label="Go to top"
                onClick={onLogoClick}
              >
                <img src={penspaceLogo} alt="Penspace" className={styles.logoImg} />
              </button>
            ) : (
              <Link to="/" className={styles.logoLink} aria-label="Go to Home">
                <img src={penspaceLogo} alt="Penspace" className={styles.logoImg} />
              </Link>
            )}
          </div>
          <nav className={`${styles.nav} ${mobileMenuOpen ? styles.mobileOpen : ""}`}>
            {showHome && (
              <Link to="/" className={styles.navLink}>
                Home
              </Link>
            )}
            {NAV_LINKS.map(({ to, label }) =>
              useAnchorLinks ? (
                <a
                  key={to}
                  href={to}
                  className={styles.navLink}
                  onClick={(e) => onNavClick(e, to)}
                >
                  {label}
                </a>
              ) : (
                <Link key={to} to={to} className={styles.navLink}>
                  {label}
                </Link>
              )
            )}
          </nav>
          {onMobileMenuToggle && (
            <button
              type="button"
              className={styles.mobileMenuBtn}
              aria-label="Toggle menu"
              onClick={onMobileMenuToggle}
            >
              ☰
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
